module.exports = {
    "message.transform.downStep": "ขั้นตอนถัดไป",
    "message.CreateTransferOrder.receiverPostCode": "รหัสไปรษณีย์รับ",
    "message.inboundView.button.createInboundBtn": "สร้าง IO ใหม่",
    "message.lzdInboundDetail.lzdItemTable.sellerSku": "ผู้ขาย SKU",
    "message.login.switch_to_vi_vn": "Chuyển sang tiếng Việt",
    "message.table.fulfillment.shippingTypeDesc": "ประเภทการจัดส่ง",
    "message.views.activityInventory.platformSkuName": "ชื่อ SKU แพลตฟอร์ม",
    "message.views.publishTemplateView.longDesc": "คำอธิบายยาว",
    "message.views.scItemView.merchant": "พ่อค้า",
    "message.views.stockAllocation.scItemId": "Scitemid",
    "message.aegInboundDetail.title.basicInformation": "ข้อมูลพื้นฐาน",
    "message.menu.createNewInboundOrder": "สร้างคำสั่งซื้อขาเข้าใหม่",
    "message.views.feedback.systemRate": "อัตราระบบ",
    "message.form.fulfillment.cbFulfillmentOrderId": "รหัสการสั่งซื้อของ CB",
    "message.views.inventoryReconciliation.endDateStock": "สิ้นสุดวันที่สต็อก",
    "message.views.inventoryLedger.inventoryTypeMap.good": "ดีครับ",
    "message.views.workbench.all": "ทั้งหมด",
    "message.outboundView.title.outboundOrderNo": "หมายเลขขาออก",
    "message.lzdInboundDetail.title.sellerAddress": "ที่อยู่ผู้ขาย",
    "message.views.liveInventory.unSellable": "ไม่สามารถขายได้",
    "message.outboundView.table.creator": "ผู้สร้าง",
    "message.views.inventoryLedger.inventoryType": "ประเภทสินค้าคงคลัง",
    "message.aegOutboundOrderDetail.purchaseItemColumn.quantityDec": "ปริมาณ",
    "message.views.scItemView.itemSite": "เว็บไซต์ผลิตภัณฑ์",
    "message.views.scItemView.upShelf": "ชั้นวางของ",
    "message.views.inventoryAging.greate180day": "มากกว่า180วัน",
    "message.aegOutboundOrderDetail.title.createTime": "สร้างเวลา",
    "message.lzdOutboundViewDetail.title.logisticLogs": "เข้าสู่ระบบโลจิสติก",
    "message.views.inventoryLedger.orderTypeMap.B2B_PURCHASE_IN": "การจัดส่งขาเข้าล้มเหลว",
    "message.table.fulfillment.tradeOrderId": "รหัสคำสั่งซื้อขาย",
    "message.views.liveInventory.onWayName": "ระหว่างทาง",
    "message.inboundView.table.planQuantity": "ปริมาณแผน",
    "message.views.productView.fulfillmentSku": "Fulfillmentsku",
    "message.transform.toTransfer": "เพื่อโอน",
    "message.views.dashboardScore.table.rate": "ให้คะแนน",
    "message.aegOutboundOrderDetail.logisticColumns.fulfillStatus": "ตอบสนองสถานะ",
    "message.views.workbench.channelItemSold": "ช่องรายการขาย",
    "message.aegInboundDetail.goodsTable.quantityDec": "ปริมาณการซื้อ",
    "message.outboundView.title.platform": "แพลตฟอร์ม",
    "message.views.workbench.toDeliver": "เพื่อส่งมอบ",
    "message.menu.feedback.dashboardScore": "คะแนนแดชบอร์ด",
    "message.views.feedback.feedbackOptions.productSuggestion": "แนะนำผลิตภัณฑ์",
    "message.card.fulfillment.trackingNumber": "หมายเลขติดตาม",
    "message.inboundView.button.template": "แม่แบบ",
    "message.inboundView.table.warehouse": "คลังสินค้า",
    "message.lzdInboundPlanView.replenishColumns.scItemName": "ชื่อ SKU",
    "message.CreateTransferOrder.senderTel": "ผู้ส่งโทรศัพท์",
    "message.transform.bindFailedAndDownload": "สินค้าคงคลังที่มีผลผูกพันล้มเหลวดาวน์โหลดรายละเอียดความล้มเหลว",
    "message.lzdOutboundViewDetail.title.outboundOrderCode": "ขาออกไม่มี",
    "message.modal.pdfTitle": "สร้าง PDF เรียบร้อยแล้ว",
    "message.views.workbench.dashboardDescription.totalProductSoldQuantity": "สินค้าทั้งหมดที่ขาย: ปริมาณสินค้าทั้งหมดในคลังสินค้าทั้งหมดที่ออกใบสั่งเนื้อหาแดชบอร์ด: ข้อมูลปริมาณการขายผลิตภัณฑ์ในช่วงเจ็ดวันที่ผ่านมาสินค้ารายวันที่ขาย: ปริมาณสินค้าทั้งหมดในคลังสินค้าทั้งหมดที่ออกคำสั่งซื้อในวันนี้",
    "message.login.switch_to_en_us": "Switch To English",
    "message.views.stockAllocation.platformSkuCode": "รหัส SKU แพลตฟอร์ม",
    "message.aegOutboundOrderDetail.purchaseItemColumn.remark": "หมายเหตุ",
    "message.views.liveInventory.onWay.inBoundOnWay": "ขาเข้า",
    "message.CreateTransferOrder.receiverInfo": "ข้อมูลตัวรับสัญญาณ",
    "message.taskCenterView.title.taskStatus": "สถานะการทำงาน",
    "message.message.fulfillment.shippingSuccess": "ความสำเร็จในการจัดส่ง!",
    "message.outboundView.table.merchantCode": "รหัสร้านค้า",
    "message.aegInboundDetail.purchaseItemColumn.scItemId": "การตอบสนอง SKU",
    "message.transform.waitingMention": "คาดว่าสินค้าคงคลังจะใช้เวลาไม่กี่นาทีโปรดอย่าปิดหน้าปัจจุบัน",
    "message.views.workbench.dod": "อัตราส่วนรายวัน",
    "message.outboundView.button.exportBtn": "ส่งออก",
    "message.card.fulfillment.receiverPhone": "โทรศัพท์รับสัญญาณ",
    "message.outboundView.table.cancel": "ขอยกเลิก",
    "message.views.scItemView.platformSkuDetail": "รายละเอียด platformsku",
    "message.views.workbench.today": "วันนี้",
    "message.views.scItemView.searchButton": "ค้นหา",
    "message.table.fulfillment.fulfillmentOrderItemId": "ID รายการสั่งซื้อ",
    "message.menu.dashboard": "แดชบอร์ด",
    "message.aegOutboundOrderDetail.purchaseItemColumn.barcode": "Barecode",
    "message.views.stockAllocation.edit": "แก้ไข",
    "message.aegOutboundOrderDetail.purchaseItemColumn.scItemId": "รหัสสินค้า",
    "message.card.fulfillment.receiverZip": "ซิปรับสัญญาณ",
    "message.views.inventoryReconciliation.stockChange": "การเคลื่อนไหวของสต็อก",
    "message.views.productView.fulfillmentTitle": "ชื่อ fulfillmentsku",
    "message.CreateTransferOrder.receiverTel": "ตัวรับสัญญาณโทรศัพท์",
    "message.aegInboundDetail.logisticColumns.fulfillStatusDesc": "คำอธิบายสถานะ",
    "message.views.workbench.suggestToReplenish": "แนะนำให้เติมเต็ม",
    "message.views.inventoryReconciliation.changeTypeMap.totalSellerInboundedStock": "ผู้ขาย inbounded",
    "message.transform.shopBindFailed": "ผูกร้านค้าล้มเหลว",
    "message.views.inventoryLedger.orderTypeMap.OTHER_INBOUND": "ลูกค้าคืนขาเข้า",
    "message.views.workbench.toReplenishment": "TO replenishment คำกริยา",
    "message.button.print": "พิมพ์",
    "message.views.workbench.channelSales": "ช่อง GMV",
    "message.views.productPublishView.inputSearchText": "ใส่ข้อความค้นหา",
    "message.menu.fulfillment": "การปฏิบัติตาม",
    "message.card.fulfillment.buyerName": "ชื่อผู้ซื้อ",
    "message.table.fulfillment.itemId": "รหัสสินค้า",
    "message.lzdOutboundViewDetail.title.userNick": "ผู้ใช้ NICK",
    "message.aegInboundDetail.title.actualArrivalTime": "เวลามาถึงจริง",
    "message.aegInboundDetail.logisticColumn.bizOrderNo": "ไม่มีคำสั่งซื้อ Biz",
    "message.CreateTransferOrder.senderAddress": "ที่อยู่ผู้ส่ง",
    "message.CreateTransferOrder.deliverType": "ประเภทการจัดส่ง",
    "message.table.fulfillment.shippingType": "รหัสประเภทการจัดส่ง",
    "message.table.fulfillment.actualItemPaidFee": "ค่าธรรมเนียมการจ่ายสินค้าจริง",
    "message.views.inventoryAging.150-180day": "150-180วัน",
    "message.views.stockAllocation.fulfillmentSkuName": "ชื่อ SKU ตามความต้องการ",
    "message.views.activityInventory.site": "ไซต์ไหนคะ",
    "message.lzdOutboundViewDetail.title.SKU": "SKU",
    "message.lzdInboundDetail.title.shop": "ร้านค้า",
    "message.button.orderExport": "ส่งออกคำสั่งซื้อ",
    "message.inboundView.button.exportAllOrder": "ส่งออกคำสั่งซื้อทั้งหมด",
    "message.lzdInboundCreateView.addSkuView.scItemName": "ชื่อสินค้า",
    "message.card.fulfillment.tradePayTime": "เวลาจ่ายการค้า",
    "message.transform.recentBindInventoryRecord": "ผลลัพธ์ที่มีผลผูกพันสินค้าคงคลังล่าสุด",
    "message.table.fulfillment.receiverProvince": "รับจังหวัด",
    "message.drawer.fulfillment.shippingName": "ชื่อการจัดส่ง",
    "message.menu.scItemView": "สินค้า",
    "message.card.fulfillment.receiverName": "ชื่อผู้รับ",
    "message.login.switch_to_another_language": "切换为中文",
    "message.table.fulfillment.orderItemStatus": "รหัสสถานะสินค้าสั่งซื้อ",
    "message.lzdInboundPlanView.queryForm.scItemCode": "การตอบสนอง SKU",
    "message.views.productPublishView.publishShop": "เผยแพร่ร้านค้า",
    "message.views.scItemView.shelfLifeManagement": "การจัดการอายุการเก็บรักษา",
    "message.views.inventoryLedger.inventoryTypeMap.onWay": "ระหว่างทาง",
    "message.transform.startShopBindCheck": "เริ่มต้นการจัดเก็บ Binding check",
    "message.login.user_profile": "โปรไฟล์ผู้ใช้",
    "message.CreateTransferOrder.receiverCountry": "ประเทศรับ",
    "message.transform.success": "ความสำเร็จ",
    "message.views.liveInventory.unSellableOccupy": "สงวน unsellable",
    "message.inboundView.alert.cancel": "ขอยกเลิก",
    "message.table.fulfillment.cod": "COD",
    "message.views.inventoryReconciliation.changeTypeMap.totalOtherInboundedStock": "Inbounded อื่นๆ",
    "message.views.workbench.wow": "อัตราส่วนรายสัปดาห์",
    "message.table.fulfillment.unitPrice": "ราคาต่อหน่วย",
    "message.lzdInboundCreateView.addSkuView.addSkuTitle": "เพิ่ม SKU",
    "message.inboundView.title.createTime": "สร้างเวลา",
    "message.views.workbench.totalGmv": "รวม GMV",
    "message.outboundView.table.orderQuantity": "ปริมาณ",
    "message.views.inventoryLedger.changeQuantity": "เปลี่ยนปริมาณ",
    "message.views.scItemView.mainShop": "Mainshop",
    "message.transform.unfinished": "ยังไม่เสร็จ",
    "message.views.feedback.feedbackType": "ประเภทปัญหา",
    "message.views.scItemView.length": "ความยาว",
    "message.views.liveInventory.warehouseName": "ชื่อคลังสินค้า",
    "message.form.fulfillment.tradeOrderId": "รหัสคำสั่งซื้อขาย",
    "message.views.inventoryLedger.orderTypeMap.INVENTORY_STATUS_ADJUST_OUT": "สถานะสินค้าคงคลังปรับ",
    "message.lzdInboundCreateView.tableColumn.warehouse": "คลังสินค้า",
    "message.views.productView.price": "สมราคา",
    "message.outboundView.title.returnReason": "เหตุผลคืน",
    "message.inboundView.table.operate": "ดำเนินการ",
    "message.aegInboundDetail.purchaseItemColumn.title": "ผู้ขาย SKU",
    "message.views.workbench.activityResult": "ผลกิจกรรม",
    "message.views.dashboardScore.dashboardName.proportion_of_shop_product_sold": "สัดส่วนของสินค้าร้านค้าที่ขาย",
    "message.table.fulfillment.buyerName": "ชื่อผู้ซื้อ",
    "message.menu.productPublishView": "เผยแพร่ผลิตภัณฑ์",
    "message.views.stockAllocation.totalInventory": "สินค้าคงคลังทั้งหมด",
    "message.inboundView.table.cancel": "ขอยกเลิก",
    "message.lzdInboundCreateView.addSkuView.resetBtn": "รีเซ็ต",
    "message.views.inventoryLedger.inventoryTypeMap.defective": "ชำรุด",
    "message.views.productPublishView.brand": "แบรนด์",
    "message.views.workbench.dashboardDescription.channelProductSold": "แผนภูมิแท่งของผลิตภัณฑ์ที่ขายจากช่องทางต่างๆในสัปดาห์ที่แล้ว",
    "message.views.workbench.operation": "การดำเนินงาน",
    "message.lzdInboundDetail.lzdItemTable.scItemCode": "รหัสสินค้า",
    "message.transform.startCheck": "เริ่มตรวจสอบการผูกสินค้าคงคลัง",
    "message.table.fulfillment.skuId": "รหัส SKU",
    "message.menu.fulfillmentOrderDetail": "รายละเอียดการสั่งซื้อ Fulfillment",
    "message.common.detail": "รายละเอียด",
    "message.views.productPublishView.skuImage": "ภาพ SKU",
    "message.views.productPublishView.import": "นำเข้า",
    "message.views.dashboardScore.dashboardName.monthly_product_sold_and_item_ranking": "ผลิตภัณฑ์รายเดือนที่ขายและการจัดอันดับสินค้า",
    "message.views.productView.skuStatus": "สถานะ SKU",
    "message.outboundView.table.merchantName": "ชื่อร้านค้า",
    "message.views.dashboardScore.table.operation": "การดำเนินงาน",
    "message.inboundView.table.creator": "ผู้สร้าง",
    "message.views.productView.brand": "แบรนด์",
    "message.views.inventoryAging.inventoryType": "ประเภทสินค้าคงคลัง",
    "message.aegInboundDetail.logisticColumn.operateTime": "เวลาใช้งาน",
    "message.views.activityInventory.search": "ค้นหา",
    "message.lzdInboundCreateView.addSkuView.searchBtn": "ค้นหา",
    "message.lzdInboundCreateView.addSkuView.shelfLife": "อายุการเก็บรักษา",
    "message.views.activityInventory.fulfillmentSkuName": "ชื่อ SKU ตามความต้องการ",
    "message.transform.stockBindStore": "ร้านค้าที่ถูกผูกไว้",
    "message.views.scItemView.fileExport": "ส่งออก",
    "message.transform.transferred": "โอนแล้ว",
    "message.aegInboundDetail.goodsTable.defectiveQtyDec": "ปริมาณที่มีข้อบกพร่อง",
    "message.inboundView.table.expiredTime": "เวลาหมดอายุ",
    "message.menu.inboundPlanItemDetail": "รายละเอียดของแผนเติมเต็ม",
    "message.views.stockAllocation.allLessThan100": "อัตราส่วนทั้งหมดไม่ได้รับอนุญาตน้อยกว่า100โปรดปรับ",
    "message.transform.auth": "การอนุมัติ",
    "message.views.inventoryLedger.operateTime": "เวลาการดำเนินงาน",
    "message.aegOutboundOrderDetail.logisticColumns.fulfillStatusDesc": "ปฏิบัติตามสถานะ desc",
    "message.transform.bindException": "ข้อยกเว้นการผูกสินค้าคงคลัง",
    "message.views.scItemView.height": "ความสูง",
    "message.views.workbench.shopGmvProportion": "สัดส่วนของ GMV",
    "message.views.inventoryLedger.orderTypeMap.INVENTORY_STATUS_ADJUST_IN": "สถานะสินค้าคงคลังปรับ",
    "message.views.productPublishView.upload": "อัปโหลด",
    "message.login.switch_to_zh_cn": "切换为中文",
    "message.button.helpCenter": "ศูนย์ช่วยเหลือ",
    "message.aegInboundDetail.purchaseItemColumn.measureUnit": "หน่วยวัด",
    "message.views.workbench.shopName": "ชื่อร้าน",
    "message.menu.inOutBound": "ขาเข้าและขาออก",
    "message.views.publishTemplateView.templateName": "Templatename",
    "message.views.inventoryLedger.orderTypeMap.CHECK_OUT": "การสูญเสียการนับรอบ",
    "message.views.productView.showRelation": "แสดงความสัมพันธ์",
    "message.transform.bindFailed": "การผูกสินค้าคงคลังล้มเหลว",
    "message.form.fulfillment.plName": "ผู้ให้บริการจัดส่ง",
    "message.views.productView.searchButton": "ค้นหา",
    "message.lzdInboundDetail.lzdItemTable.scItemName": "ชื่อสินค้า",
    "message.menu.createNewOutboundOrder": "สร้างคำสั่งซื้อขาออกใหม่",
    "message.lzdInboundCreateView.addSkuView.platformSku": "SKU แพลตฟอร์ม",
    "message.aegInboundDetail.logisticColumn.operator": "ผู้ประกอบการ",
    "message.outboundView.title.createTime": "สร้างเวลา",
    "message.select.fulfillment.completeShipping": "จัดส่งทั้งหมด",
    "message.card.fulfillment.tradeOrderItemId": "หมายเลขคำสั่งซื้อสินค้า",
    "message.drawer.fulfillment.ship": "เรือ",
    "message.form.fulfillment.inputTrackingNumber": "โปรดป้อนหมายเลขติดตาม!",
    "message.views.scItemView.reload": "เลือกที่ชัดเจน",
    "message.menu.taskCenterItem": "ศูนย์ดาวน์โหลด",
    "message.menu.fulfillmentOrder": "สั่งแล้ว",
    "message.views.productView.scItemMerchant": "Fulfillmentsku ร้านค้า",
    "message.views.workbench.allShop": "ร้านค้าทั้งหมด",
    "message.transform.isDone": "เสร็จแล้ว",
    "message.views.stockAllocation.platformSkuName": "ชื่อ SKU แพลตฟอร์ม",
    "message.views.productView.platformSkuDetail": "รายละเอียด SKU",
    "message.outboundView.button.exportSelectedOrder": "ส่งออกคำสั่งซื้อที่เลือก",
    "message.table.fulfillment.cbOrderStatusDesc": "สถานะการสั่งซื้อ CB",
    "message.menu.fulfillmentPackageDetail": "รายละเอียดแพ็คเกจ Fulfillment",
    "message.views.feedback.feedbackOptions.systemBug": "ข้อผิดพลาดของระบบ",
    "message.views.stockAllocation.adjustStockSuccess": "ปรับสต็อกความสำเร็จ",
    "message.table.fulfillment.sellerSku": "ผู้ขาย SKU",
    "message.views.workbench.dailyProductSold": "จำหน่ายผลิตภัณฑ์ประจำวัน",
    "message.table.fulfillment.totalFee": "ค่าธรรมเนียมทั้งหมด",
    "message.lzdInboundDetail.lzdItemTable.itemCompleted": "สินค้าเสร็จสมบูรณ์",
    "message.menu.demoDashboard": "สาธิตแดชบอร์ด",
    "message.views.productView.barcode": "บาร์โค้ด",
    "message.outboundView.title.fulfilmentOrderCode": "ปฏิบัติตามคำสั่งซื้อหมายเลข",
    "message.views.workbench.productSold": "สินค้าที่ขาย",
    "message.views.scItemView.shop": "ร้านค้า",
    "message.inboundView.button.AegTemplate": "AE ทั่วโลก",
    "message.views.scItemView.scItemMerchant": "Fulfillmentsku ร้านค้า",
    "message.transform.itemCheck": "แพลตฟอร์ม SKU/fulfillmentsku ตรวจสอบ",
    "message.taskCenterView.table.downLoad": "ดาวน์โหลด",
    "message.views.scItemView.operation": "การดำเนินงาน",
    "message.lzdOutboundViewDetail.title.address": "ที่อยู่",
    "message.table.fulfillment.warehouseCode": "รหัสคลังสินค้า",
    "message.card.fulfillment.deliveryInfomation": "ข้อมูลการจัดส่ง",
    "message.aegInboundDetail.goodsTable.scItemId": "การตอบสนอง SKU",
    "message.menu.gfc.enter": "ใส่ GFC",
    "message.lzdInboundDetail.title.inboundOrderCode": "หมายเลขคำสั่งขาเข้า",
    "message.form.fulfillment.fulfillmentOrderId": "ปฏิบัติตามรหัสคำสั่งซื้อ",
    "message.views.liveInventory.warehouse": "คลังสินค้า",
    "message.table.fulfillment.receiverCountry": "ประเทศรับ",
    "message.views.publishTemplateView.shortDesc": "คำอธิบายสั้นๆ",
    "message.outboundView.button.exportAllOrder": "ส่งออกคำสั่งซื้อทั้งหมด",
    "message.aegInboundDetail.title.cancelReason": "เหตุผลที่ถูกยกเลิก",
    "message.aegInboundDetail.purchaseItemColumn.receivedDefectiveQtyDec": "ได้รับจำนวนที่มีข้อบกพร่อง",
    "message.views.stockAllocation.stockAllocation": "ปรับสต็อก",
    "message.transform.startBind": "เริ่มต้นร้านค้าผูกตรวจสอบ",
    "message.aegOutboundOrderDetail.consignColumn.gmtCreateStr": "สร้างเวลา",
    "message.views.workbench.orderQuantity": "ปริมาณการสั่งซื้อ",
    "message.card.fulfillment.shippingProviderName": "ชื่อผู้ให้บริการจัดส่งสินค้า",
    "message.aegInboundDetail.purchaseItemColumn.sentQty": "ส่งจำนวน",
    "message.transform.downloadErrorFileUrl": "ลิงก์ดาวน์โหลดไฟล์ข้อผิดพลาด",
    "message.transform.mentionInfo": "คาดว่าสินค้าคงคลังจะใช้เวลาไม่กี่นาทีอย่าปิดหน้าปัจจุบัน",
    "message.aegOutboundOrderDetail.consignColumn.formatPreArriveTime": "เวลามาถึงก่อน",
    "message.views.stockAllocation.outChannel": "ช่องออก",
    "message.table.fulfillment.sellerId": "รหัสผู้ขาย",
    "message.login.log_out": "ออกจากระบบ",
    "message.card.fulfillment.receiverCountry": "ประเทศรับ",
    "message.views.inventoryReconciliation.changeTypeMap.totalOtherOutbounded": "Outbounded อื่นๆ",
    "message.views.workbench.orderTime": "เวลาสั่งซื้อ",
    "message.views.liveInventory.cargo": "สินค้า",
    "message.aegOutboundOrderDetail.title.outboundTime": "เวลาขาออก",
    "message.views.workbench.dashboardDescription.totalOrderQuantity": "สินค้าทั้งหมดที่ขาย: ผลรวมของคำสั่งซื้อคลังสินค้าทั้งหมดอัตราส่วนรายสัปดาห์: (ปริมาณการสั่งซื้อของสัปดาห์นี้-ปริมาณการสั่งซื้อของสัปดาห์นี้ของปีที่แล้ว)/ปริมาณการสั่งซื้อของสัปดาห์นี้ของปีที่ผ่านมา, อัตราส่วนรายวัน (ปริมาณการสั่งซื้อของวันนี้-ปริมาณการสั่งซื้อของวันนี้ของปีที่ผ่านมา) /ปริมาณการสั่งซื้อของวันนี้ของปีที่ผ่านมาปริมาณการสั่งซื้อวัน: ผลรวมของคำสั่งซื้อของวันนี้",
    "message.lzdInboundDetail.title.ioType": "ประเภท IO",
    "message.CreateTransferOrder.senderCountry": "ประเทศผู้ส่ง",
    "message.aegOutboundOrderDetail.title.basicInformation": "ข้อมูลพื้นฐาน",
    "message.aegInboundDetail.title.expiredTime": "เวลาหมดอายุ",
    "message.views.inventoryLedger.orderTypeMap.ADJUST_IN": "ปรับใน",
    "message.views.inventoryLedger.resultQuantity": "ปริมาณผลลัพธ์",
    "message.button.printPdf": "พิมพ์ PDF",
    "message.select.fulfillment.deliveryFailed": "การจัดส่งล้มเหลว",
    "message.form.fulfillment.merchantList": "พ่อค้า",
    "message.outboundView.table.supplier": "ผู้จัดจำหน่าย",
    "message.taskCenterView.table.taskId": "รหัสงาน",
    "message.lzdInboundCreateView.tableColumn.sellerCity": "เมืองผู้ขาย",
    "message.card.fulfillment.shipperId": "รหัสเจ้าของคำสั่งซื้อ",
    "message.aegInboundDetail.title.cancelPerson": "ยกเลิกคน",
    "message.lzdInboundCreateView.tableColumn.addBtn": "เพิ่ม",
    "message.views.workbench.productSoldRank": "การจัดอันดับการขายผลิตภัณฑ์",
    "message.card.fulfillment.receiverProvince": "รับจังหวัด",
    "message.inboundView.title.orderStatus": "สถานะ",
    "message.card.fulfillment.itemInfomation": "ข้อมูลสินค้า",
    "message.inboundView.table.skuQuantity": "ปริมาณ",
    "message.views.stockAllocation.warehouse": "คลังสินค้า",
    "message.aegOutboundOrderDetail.logisticColumns.bizOrderNo": "ไม่มีคำสั่งซื้อ Biz",
    "message.table.fulfillment.totalItemFee": "รวมค่าธรรมเนียมสินค้า",
    "message.menu.inboundPlanItem": "การเติมเต็ม",
    "message.views.scItemView.itemCode": "Itemcodes",
    "message.message.fulfillment.deliveryConfirm": "ยืนยันการจัดส่ง!",
    "message.button.submit": "ส่งไว",
    "message.menu.inventoryLedger": "บัญชีแยกประเภทสินค้าคงคลัง",
    "message.card.fulfillment.fulfillmentOrderInformation": "ข้อมูลการสั่งซื้อ",
    "message.inboundView.alert.selectFile": "เลือกไฟล์",
    "message.table.fulfillment.cbOrderStatus": "รหัสสถานะการสั่งซื้อ CB",
    "message.views.inventoryReconciliation.dateRange": "ช่วงวันที่",
    "message.inboundView.table.merchantName": "ชื่อร้านค้า",
    "message.views.workbench.dailyItemSold": "สินค้ารายวันขาย",
    "message.lzdInboundDetail.title.warehouseName": "คลังสินค้า",
    "message.views.workbench.skuNum": "หมายเลข SKU",
    "message.views.scItemView.bindRelatedPlatformSku": "ผูกสินค้าที่เกี่ยวข้อง",
    "message.views.liveInventory.occupy": "ตัวล็อค",
    "message.menu.activityInventory": "สินค้าคงคลังกิจกรรม",
    "message.table.fulfillment.orderType": "ประเภทการสั่งซื้อ",
    "message.aegInboundDetail.title.warehouseAddress": "ที่อยู่",
    "message.menu.feedback.feedbackName": "ข้อเสนอแนะ",
    "message.drawer.fulfillment.deliveryFailed": "การจัดส่งล้มเหลว",
    "message.views.dashboardScore.dashboardName.all_authorized_shop": "ร้านค้าที่ได้รับอนุญาตทั้งหมด",
    "message.aegInboundDetail.title.createTime": "สร้างเวลา",
    "message.table.fulfillment.orderStatus": "รหัสสถานะการสั่งซื้อ",
    "message.lzdInboundDetail.title.deliverType": "ส่งประเภท",
    "message.views.workbench.cargo": "สินค้า",
    "message.lzdInboundCreateView.addSkuView.operate": "ดำเนินการ",
    "message.outboundView.button.LzdTemplate": "แม่แบบ lazada",
    "message.transform.bindCheckFailed": "การตรวจสอบการผูกสินค้าคงคลังล้มเหลว",
    "message.form.fulfillment.deliveryType": "ยืนยันการจัดส่ง",
    "message.views.activityInventory.campaignName": "ชื่อแคมเปญ",
    "message.outboundView.table.warehouse": "คลังสินค้า",
    "message.views.workbench.inbound": "ขาเข้า",
    "message.login.language": "ภาษา",
    "message.transform.selectShop": "เลือกร้านค้า",
    "message.common.reset": "รีเซ็ต",
    "message.card.fulfillment.shippingServiceCode": "รหัสบริการจัดส่ง",
    "message.views.feedback.feedbackContent": "Feedbackcontent",
    "message.views.workbench.shopItemSoldData": "สัดส่วนของสินค้าที่ขาย",
    "message.views.inventoryAging.121-150day": "121-150วัน",
    "message.views.scItemView.productType": "ประเภทผลิตภัณฑ์",
    "message.table.fulfillment.siteId": "รหัสเว็บไซต์",
    "message.table.fulfillment.sellerName": "ชื่อผู้ขาย",
    "message.inboundView.table.orderStatus": "สถานะ",
    "message.menu.liveInventory": "สินค้าคงคลังสด",
    "message.views.workbench.mom": "แม่",
    "message.modal.pdfContext": "ไปพิมพ์หรือดาวน์โหลด",
    "message.drawer.fulfillment.shippingType": "ประเภทการจัดส่ง",
    "message.transform.shopBindFailedAndDownload": "เก็บผูกพันล้มเหลวดาวน์โหลดรายละเอียดความล้มเหลว",
    "message.transform.bindSuccess": "สินค้าคงคลังที่มีผลผูกพันสำเร็จ",
    "message.views.dashboardScore.table.comment": "ความคิดเห็น",
    "message.CreateTransferOrder.destEntityCode": "คลังสินค้า dest",
    "message.lzdInboundCreateView.title.basicFlag": "ข้อมูลพื้นฐาน",
    "message.form.fulfillment.reverseTradeOrderId": "รหัสสั่งซื้อย้อนกลับ",
    "message.views.stockAllocation.fulfillmentSkuCode": "รหัสสินค้า SKU",
    "message.outboundView.title.orderStatus": "สถานะการสั่งซื้อ",
    "message.menu.inventory": "สินค้าคงคลัง",
    "message.menu.gfc.title": "ใส่ GFC",
    "message.message.fulfillment.batchShippingMessage": "คุณสามารถเลือกคำสั่งซื้อจากร้านค้ารายหนึ่งในเวลาสำหรับการจัดส่งเท่านั้น!",
    "message.views.dashboardScore.dashboardName.effect_of_operation_activity": "ผลกระทบของกิจกรรมการดำเนินงาน",
    "message.card.fulfillment.promiseEarliestDate": "สัญญาวันที่เร็วที่สุด",
    "message.views.dashboardScore.dashboardName.all_product_sold": "ขายผลิตภัณฑ์ทั้งหมด",
    "message.inboundView.table.receivedQuantity": "ปริมาณที่ได้รับ",
    "message.views.inventoryAging.fulfillmentSkuCode": "รหัสสินค้า SKU",
    "message.outboundView.table.platform": "แพลตฟอร์ม",
    "message.outboundView.button.search": "ค้นหา",
    "message.views.liveInventory.name": "ชื่อ",
    "message.CreateTransferOrder.estimatedOutboundTime": "เวลาขาออกโดยประมาณ",
    "message.card.fulfillment.fulfillmentOrderItemId": "ID รายการสั่งซื้อ",
    "message.views.liveInventory.warehouseCode": "รหัสคลังสินค้า",
    "message.views.productPublishView.publishTemplate": "เผยแพร่แม่แบบ",
    "message.table.fulfillment.scItemId": "รหัสสินค้า SC",
    "message.lzdOutboundViewDetail.title.sellerName": "ชื่อผู้ขาย",
    "message.menu.item": "สินค้า/สินค้า",
    "message.lzdInboundCreateView.addSkuView.quantity": "ปริมาณที่ต้องการ",
    "message.views.productPublishView.pleaseSelectTheCategory": "โปรดเลือกหมวดหมู่",
    "message.views.scItemView.temperatureCondition": "สภาพอุณหภูมิ",
    "message.views.productPublishView.atLeastOneImage": "อย่างน้อยหนึ่งภาพที่จำเป็น",
    "message.views.productPublishView.plsChooseTemplateToPublish": "คุณสามารถเลือกเทมเพลตเพื่อเผยแพร่",
    "message.views.inventoryLedger.orderType": "ประเภทการสั่งซื้อ",
    "message.lzdInboundDetail.lzdItemTable.itemRequested": "สินค้าที่ร้องขอ",
    "message.table.fulfillment.receiverPhone": "โทรศัพท์รับสัญญาณ",
    "message.menu.authorization.title": "การอนุมัติ",
    "message.views.scItemView.addRelatedPlatformSku": "ที่เกี่ยวข้อง platformsku",
    "message.transform.startShopBind": "เริ่มต้นผูกร้านค้า",
    "message.transform.startTime": "เวลาเริ่มต้น",
    "message.table.fulfillment.warehouseName": "ชื่อคลังสินค้า",
    "message.transform.selectStoresToBindInventory": "เลือกร้านค้าที่จะผูกสินค้าคงคลัง",
    "message.views.productView.platformSku": "แพลตฟอร์ม SKU",
    "message.views.scItemView.platformTitle": "ชื่อ platformsku",
    "message.views.dashboardScore.dashboardName.to_supplement": "เพื่อเสริม",
    "message.form.fulfillment.warehouseCode": "รหัสคลังสินค้า",
    "message.lzdInboundDetail.title.mobile": "มือถือ",
    "message.views.liveInventory.onWay.transferOnWay": "โอน onway",
    "message.CreateTransferOrder.receiverName": "ชื่อผู้รับ",
    "message.lzdInboundCreateView.tableColumn.contactInfo": "ติดต่อกลับ",
    "message.transform.errorFile": "ไฟล์ข้อผิดพลาด",
    "message.views.productView.skuStock": "สต็อก SKU",
    "message.menu.stockAllocation": "การจัดการสินค้าคงคลังช่องทาง",
    "message.aegInboundDetail.title.skus": "SKUs",
    "message.menu.feedback.feedback": "ข้อเสนอแนะ",
    "message.aegInboundDetail.goodsTable.normalQtyDec": "ปริมาณปกติ",
    "message.inboundView.button.LzdTemplate": "Lazada",
    "message.views.workbench.authorizationShop": "ร้านค้าที่ได้รับอนุญาต",
    "message.form.fulfillment.inputShippingName": "กรุณาใส่ชื่อจัดส่ง!",
    "message.views.workbench.dailyOrderQuantity": "ปริมาณการสั่งซื้อรายวัน",
    "message.views.workbench.totalOrderQuantity": "ปริมาณการสั่งซื้อทั้งหมด",
    "message.aegInboundDetail.goodsTable.barcode": "บาร์โค้ด",
    "message.views.stockAllocation.inChannel": "ในช่อง",
    "message.views.stockAllocation.allMoreThan100": "อัตราส่วนทั้งหมดไม่ได้รับอนุญาตมากกว่า100โปรดปรับ",
    "message.aegOutboundOrderDetail.consignColumn.operate": "ดำเนินการ",
    "message.lzdInboundDetail.title.basicInformation": "ข้อมูลพื้นฐาน",
    "message.views.workbench.dailyGmv": "ทุกวัน GMV",
    "message.transform.firstStep": "ขั้นตอนแรก",
    "message.aegOutboundOrderDetail.title.creator": "ผู้สร้าง",
    "message.views.publishTemplateView.templateDetail": "รายละเอียดแม่แบบ",
    "message.card.fulfillment.orderStatus": "สถานะการสั่งซื้อ",
    "message.views.inventoryLedger.orderTypeMap.PURCHASE_IN": "ผู้ขาย/ผู้จัดจำหน่ายขาเข้า",
    "message.views.dashboardScore.dashboardName.to_inbound": "TO inbound คำกริยา",
    "message.transform.isSuccess": "คือความสำเร็จ",
    "message.outboundView.table.receivedQuantity": "ปริมาณที่ได้รับ",
    "message.lzdInboundPlanView.replenishColumns.replQuantity": "ปริมาณ REPL",
    "message.aegOutboundOrderDetail.purchaseItemColumn.title": "ชื่อ",
    "message.lzdInboundDetail.lzdItemTable.orderItemStatus": "สถานะสินค้า",
    "message.card.fulfillment.tradeOrderId": "รหัสคำสั่งซื้อขาย",
    "message.menu.fulfillmentPackage": "แพคเกจการปฏิบัติตาม",
    "message.aegOutboundOrderDetail.purchaseItemColumn.returnQtyDec": "ปริมาณผลตอบแทน",
    "message.lzdInboundDetail.lzdItemTable.scItemId": "รหัสสินค้า",
    "message.views.inventoryAging.61-90day": "61-90วัน",
    "message.inboundView.title.warehouseList": "คลังสินค้าขาเข้า",
    "message.inboundView.button.createOutboundBtn": "สร้าง OO ใหม่",
    "message.aegOutboundOrderDetail.consignColumn.inboundNo": "หมายเลขโลจิสติก",
    "message.transform.shopBindException": "เก็บข้อยกเว้นการผูก",
    "message.taskCenterView.button.search": "ค้นหา",
    "message.views.stockAllocation.sellableStock": "สต็อก sellable",
    "message.lzdInboundCreateView.tableColumn.sellerCountry": "ประเทศผู้ขาย",
    "message.views.productView.status": "สถานะ",
    "message.aegInboundDetail.title.cancelTime": "เวลายกเลิก",
    "message.button.search": "ค้นหา",
    "message.common.fulfillment.deliveryConfirm": "ยืนยันการจัดส่ง",
    "message.lzdInboundCreateView.tableColumn.deleteBtn": "ลบ",
    "message.views.publishTemplateView.addTemplate": "เพิ่มแม่แบบ",
    "message.views.liveInventory.sellable": "ขายได้",
    "message.views.productPublishView.plsSelectThePublishShop": "โปรดเลือกร้านค้าเผยแพร่",
    "message.transform.authStore": "ร้านค้าที่ได้รับอนุญาต",
    "message.views.productView.merchant": "พ่อค้า",
    "message.aegOutboundOrderDetail.title.inventoryType": "ประเภทสินค้าคงคลัง",
    "message.views.activityInventory.expireTime": "เวลาหมดอายุ",
    "message.views.productPublishView.pleaseChooseTheShop": "โปรดเลือกร้านค้า",
    "message.menu.authorization.auth": "Auth",
    "message.aegInboundDetail.purchaseItemColumn.quantityDec": "ปริมาณการซื้อ",
    "message.table.fulfillment.receiverMobile": "ตัวรับสัญญาณมือถือ",
    "message.aegOutboundOrderDetail.title.logisticOrderCode": "รหัสการสั่งซื้อโลจิสติก",
    "message.lzdOutboundViewDetail.title.estimateTimeStr": "เวลาโดยประมาณ",
    "message.views.scItemView.width": "ความกว้าง",
    "message.inboundView.title.platform": "แพลตฟอร์ม",
    "message.taskCenterView.table.creator": "ผู้สร้าง",
    "message.inboundView.alert.sure": "ยืนยัน",
    "message.views.workbench.merchantCode": "พ่อค้า",
    "message.views.productPublishView.plsSelectTheCategory": "โปรดเลือกหมวดหมู่",
    "message.views.workbench.deliver": "ส่งมอบ",
    "message.transform.shopBinding": "ผูกร้านค้า",
    "message.taskCenterView.button.reset": "รีเซ็ต",
    "message.views.workbench.ito": "สินค้าคงคลังพลิก",
    "message.table.fulfillment.cbFulfillmentOrderItemId": "รหัสสั่งซื้อสินค้าของ CB",
    "message.aegInboundDetail.btn.detail": "รายละเอียด",
    "message.lzdInboundDetail.title.warehouseAddress": "ที่อยู่คลังสินค้า",
    "message.outboundView.table.inventoryType": "ประเภทสินค้าคงคลัง",
    "message.views.inventoryReconciliation.changeTypeMap.totalShipped": "จัดส่งให้ลูกค้า",
    "message.views.liveInventory.commodity": "สินค้าโภคภัณฑ์",
    "message.table.fulfillment.receiverAddress": "ที่อยู่ผู้รับ",
    "message.lzdInboundDetail.title.estimateTime": "เวลาโดยประมาณ",
    "message.inboundView.title.fulfilmentOrderCode": "ปฏิบัติตามคำสั่งซื้อหมายเลข",
    "message.card.fulfillment.warehouseName": "ชื่อคลังสินค้า",
    "message.table.fulfillment.itemName": "ชื่อสินค้า",
    "message.aegOutboundOrderDetail.title.storeName": "ชื่อร้านค้า",
    "message.table.fulfillment.orderItemStatusDesc": "สถานะสินค้าสั่งซื้อ",
    "message.views.activityInventory.activeTime": "เวลาใช้งาน",
    "message.views.productView.operation": "การดำเนินงาน",
    "message.aegOutboundOrderDetail.title.skus": "SKU",
    "message.transform.InventoryBinding": "สินค้าคงคลังที่มีผลผูกพัน",
    "message.views.inventoryAging.1-30day": "1-30วันครับ",
    "message.transform.upStep": "ก่อนหน้า",
    "message.lzdOutboundViewDetail.title.inLbxOrderCode": "ปฏิบัติตามคำสั่งซื้อหมายเลข",
    "message.common.fulfillment.ship": "เรือ",
    "message.views.scItemView.itemId": "Productid",
    "message.lzdInboundCreateView.addSkuView.queryView.fulfilmentSku": "การตอบสนอง SKU",
    "message.views.productPublishView.category": "หมวดหมู่สินค้า",
    "message.inboundView.table.inboundOrder": "หมายเลขขาเข้า",
    "message.lzdInboundCreateView.title.skuFlag": "SKUs",
    "message.views.scItemView.sellerSku": "ผู้ขาย SKU",
    "message.views.productView.itemId": "รหัสสินค้า",
    "message.outboundView.button.reset": "รีเซ็ต",
    "message.views.productView.sellerSku": "ผู้ขาย SKU",
    "message.views.stockAllocation.submit": "ส่งไว",
    "message.views.productPublishView.templateDetail": "รายละเอียดแม่แบบ",
    "message.aegInboundDetail.logisticColumns.bizOrderNo": "หมายเลขการไหล",
    "message.views.stockAllocation.ratio": "อัตราส่วน",
    "message.aegOutboundOrderDetail.consignColumn.purchaseOrderNo": "หมายเลขขาออก",
    "message.inboundView.alert.shop": "เลือกร้านค้า",
    "message.transform.secondStep": "ขั้นตอนที่สอง",
    "message.lzdOutboundViewDetail.title.sellerAddress": "ที่อยู่ผู้ขาย",
    "message.views.liveInventory.seller": "ผู้ขาย",
    "message.inboundView.table.orderQuantity": "ปริมาณการสั่งซื้อ",
    "message.table.fulfillment.orderItemStatusReason": "เหตุผลสถานะสินค้าที่สั่งซื้อ",
    "message.inboundView.table.merchantCode": "รหัสร้านค้า",
    "message.aegInboundDetail.title.creator": "ผู้สร้าง",
    "message.views.productView.gmtModified": "แก้ไขเวลา",
    "message.outboundView.button.template": "แม่แบบ",
    "message.views.workbench.fulfillmentOrderId": "ปฏิบัติตามรหัสคำสั่งซื้อ",
    "message.views.feedback.feedbackOptions.questionFeedback": "ความคิดเห็นคำถาม",
    "message.views.productView.itemSite": "ไซต์ไหนคะ",
    "message.views.inventoryLedger.orderCode": "รหัสสั่งซื้อ",
    "message.taskCenterView.table.taskStatus": "สถานะงาน",
    "message.table.fulfillment.orderStatusDesc": "สถานะการสั่งซื้อ",
    "message.lzdOutboundViewDetail.title.orderStatusName": "สถานะ",
    "message.lzdInboundCreateView.title.sellerFlag": "ข้อมูลผู้ขาย",
    "message.views.scItemView.logisticsAttributes": "คุณลักษณะโลจิสติกส์",
    "message.table.fulfillment.quantity": "ปริมาณ",
    "message.views.workbench.dashboardDescription.inventoryTurnOver": "การหมุนเวียนสินค้าคงคลัง: ปริมาณการขาย/สินค้าคงคลังเฉลี่ยในเดือนที่ผ่านมา",
    "message.transform.record": "บันทึกที่ถูกผูกไว้ล่าสุด",
    "message.views.publishTemplateView.operation": "การดำเนินงาน",
    "message.views.inventoryReconciliation.changeTypeMap.totalFound": "พบว่า",
    "message.table.fulfillment.cbFulfillmentOrderId": "รหัสการสั่งซื้อของ CB",
    "message.taskCenterView.table.errorMsg": "ข้อความแสดงข้อผิดพลาด",
    "message.views.inventoryAging.91-120day": "91-120วัน",
    "message.views.inventoryAging.skuVolumn": "SKU volumn",
    "message.menu.workbench": "โต๊ะทำงาน",
    "message.aegInboundDetail.logisticColumns.fulfillStatus": "สถานะ",
    "message.lzdOutboundViewDetail.title.sellerInformation": "ข้อมูลผู้ขาย",
    "message.transform.bind": "ผูก",
    "message.views.scItemView.fulfillmentSkuDetail": "รายละเอียด fulfillmentsku",
    "message.card.fulfillment.fulfillmentOrderId": "ปฏิบัติตามรหัสคำสั่งซื้อ",
    "message.views.stockAllocation.adjustRuleFailed": "ปรับกฎล้มเหลว",
    "message.form.fulfillment.orderStatus": "สถานะการสั่งซื้อ",
    "message.transform.shopList": "รายชื่อร้านค้าที่ถูกผูกไว้",
    "message.table.fulfillment.merchantCode": "พ่อค้า",
    "message.aegOutboundOrderDetail.title.supplierId": "รหัสผู้ผลิต",
    "message.views.scItemView.brand": "แบรนด์",
    "message.transform.inventoryCheck": "ตรวจสอบสินค้าคงคลัง",
    "message.CreateTransferOrder.estimatedInboundTime": "เวลาขาเข้าโดยประมาณ",
    "message.views.workbench.thisQuarter": "ไตรมาสนี้",
    "message.lzdOutboundViewDetail.title.warehouseName": "คลังสินค้า",
    "message.select.fulfillment.partialShipping": "การจัดส่งบางส่วน",
    "message.lzdOutboundViewDetail.title.ioTypeName": "ประเภท IO",
    "message.card.fulfillment.receiverAddress": "ที่อยู่ผู้รับ",
    "message.taskCenterView.table.taskName": "ชื่องาน",
    "message.views.workbench.gmvRank": "การจัดอันดับ GMV",
    "message.lzdInboundDetail.title.orderStatus": "สถานะ",
    "message.views.activityInventory.platformSkuCode": "รหัส SKU แพลตฟอร์ม",
    "message.form.fulfillment.tradeCreateTime": "สร้างเวลา",
    "message.form.fulfillment.siteList": "ไซต์ไหนคะ",
    "message.aegOutboundOrderDetail.title.returnOrderNO": "เลขที่ใบสั่งซื้อคืนสินค้า",
    "message.drawer.fulfillment.deliverySuccess": "ความสำเร็จในการจัดส่ง",
    "message.views.workbench.noReplenishment": "ไม่มีแผนเติมเต็ม",
    "message.taskCenterView.table.operate": "ดำเนินการ",
    "message.card.fulfillment.buyerId": "รหัสผู้ซื้อ",
    "message.table.fulfillment.itemDiscountFee": "ค่าธรรมเนียมส่วนลดสินค้า",
    "message.views.scItemView.manufacturePackageDimensions": "ผลิตแพคเกจขนาด",
    "message.views.stockAllocation.cancel": "ขอยกเลิก",
    "message.outboundView.table.operate": "ดำเนินการ",
    "message.views.activityInventory.occupyQuantity": "ปริมาณครอบครอง",
    "message.views.inventoryReconciliation.changeTypeMap.totalReturnToSeller": "ผู้ขาย outbounded",
    "message.views.scItemView.status": "สถานะ",
    "message.views.stockAllocation.search": "ค้นหา",
    "message.views.scItemView.showRelation": "แสดงความสัมพันธ์",
    "message.card.fulfillment.receiverCity": "เมืองรับ",
    "message.transform.bindCheckSuccess": "ตรวจสอบการผูกสินค้าคงคลังประสบความสำเร็จ",
    "message.CreateTransferOrder.receiverAddress": "ที่อยู่ผู้รับ",
    "message.lzdInboundCreateView.tableColumn.submitBtn": "ส่งไว",
    "message.views.dashboardScore.table.dashboardName": "ชื่อแดชบอร์ด",
    "message.views.productPublishView.batchPublish": "เผยแพร่แบทช์",
    "message.menu.cbFulfillmentOrder": "คำสั่งข้ามพรมแดน",
    "message.menu.shipConfirm": "ยืนยันเรือ",
    "message.transform.ae.description": "AE ร้านค้าเข้าเล่ม",
    "message.views.dashboardScore.dashboardName.inventory_turn_over": "สินค้าคงคลังพลิก",
    "message.table.fulfillment.receiverCity": "เมืองรับ",
    "message.transform.finished": "เสร็จแล้ว",
    "message.lzdInboundDetail.lzdItemTable.goodsBarcode": "บาร์โค้ดที่ดี",
    "message.views.workbench.productSoldTendency": "แนวโน้มการขายผลิตภัณฑ์",
    "message.inboundView.title.shopName": "ร้านค้า",
    "message.card.fulfillment.receiverInfomation": "ข้อมูลตัวรับสัญญาณ",
    "message.lzdInboundCreateView.title.sellerAddress": "ที่อยู่ผู้ขาย",
    "message.button.save": "ประหยัด",
    "message.views.publishTemplateView.operator": "ผู้ประกอบการ",
    "message.table.fulfillment.fulfillmentOrderId": "ปฏิบัติตามรหัสคำสั่งซื้อ",
    "message.aegInboundDetail.logisticColumn.fulfillStatus": "ตอบสนองสถานะ",
    "message.views.publishTemplateView.search": "ค้นหา",
    "message.transform.cancel": "ขอยกเลิก",
    "message.table.fulfillment.itemShippingActualPaidFee": "ค่าจัดส่งสินค้าจริง",
    "message.outboundView.table.outboundOrder": "ลำดับขาออก",
    "message.transform.startInventoryBind": "เริ่มต้นผูกสินค้าคงคลัง",
    "message.views.dashboardScore.dashboardName.to_deliver": "เพื่อส่งมอบ",
    "message.views.scItemView.updateScItemButton": "ปรับปรุงส่ง",
    "message.menu.inboundItemName": "ขาเข้า",
    "message.CreateTransferOrder.senderName": "ชื่อผู้ส่ง",
    "message.views.scItemView.skuId": "รหัส SKU",
    "message.common.select": "เลือกโปรด",
    "message.aegOutboundOrderDetail.consignColumn.creator": "ผู้สร้าง",
    "message.views.productPublishView.mainImage": "ภาพหลัก",
    "message.table.fulfillment.receiverName": "ชื่อผู้รับ",
    "message.card.fulfillment.orderInformation": "ข้อมูลการสั่งซื้อ",
    "message.transform.shopBind": "ผูกร้านค้า",
    "message.views.inventoryLedger.orderTypeMap.TRADE_OUT": "การปฏิบัติตามขาออก",
    "message.menu.outboundItem": "ขาออก",
    "message.outboundView.table.createTime": "สร้างเวลา",
    "message.inboundView.table.platform": "แพลตฟอร์ม",
    "message.common.commit": "Commit",
    "message.views.liveInventory.code": "รหัส",
    "message.views.inventoryAging.averageAge": "อายุเฉลี่ย",
    "message.lzdInboundCreateView.tableColumn.inboundType": "ประเภทขาเข้า",
    "message.transform.failed": "ล้มเหลว",
    "message.lzdInboundCreateView.tableColumn.sellerDetail": "รายละเอียดผู้ขาย",
    "message.transform.shopBindSuccess": "เก็บเข้าเล่มเรียบร้อยแล้ว",
    "message.views.publishTemplateView.gmtCreate": "สร้างเวลา",
    "message.views.dashboardScore.dashboardName.channel_product_sold": "ช่องทางสินค้าที่ขาย",
    "message.outboundView.table.outboundReason": "เหตุผลขาออก",
    "message.transform.lzd.description": "Lazada ร้านค้าเข้าเล่ม",
    "message.views.activityInventory.scItemId": "Scitemid",
    "message.aegInboundDetail.logisticColumn.fulfillStatusDesc": "ปฏิบัติตามสถานะ desc",
    "message.outboundView.table.outboundTime": "เวลาขาออก",
    "message.form.fulfillment.shippingTypeDesc": "ประเภทการจัดส่ง",
    "message.views.scItemView.skuStatus": "สถานะ SKU",
    "message.lzdInboundCreateView.addSkuView.goodQuantity": "ปริมาณที่ดี",
    "message.menu.productView": "ผลิตภัณฑ์",
    "message.views.inventoryLedger.orderTypeMap.OUTBOUND": "ผู้ขาย/ผู้จัดจำหน่ายขาออก",
    "message.table.fulfillment.itemQuantity": "ปริมาณสินค้า",
    "message.button.cancel": "ขอยกเลิก",
    "message.views.workbench.quantity": "ปริมาณ",
    "message.views.inventoryAging.31-60day": "31-60วัน",
    "message.select.fulfillment.deliverySuccess": "ความสำเร็จในการจัดส่ง",
    "message.views.activityInventory.channelCode": "รหัสช่อง",
    "message.views.workbench.totalItemSold": "สินค้าทั้งหมดขาย",
    "message.table.fulfillment.receiverZip": "ซิปรับสัญญาณ",
    "message.lzdOutboundViewDetail.title.deliverTypeName": "ส่งชื่อประเภท",
    "message.inboundView.button.exportBtn": "ส่งออก",
    "message.inboundView.button.reset": "รีเซ็ต",
    "message.lzdInboundCreateView.tableColumn.deliverType": "ส่งประเภท",
    "message.outboundView.table.planQuantity": "ปริมาณแผน",
    "message.transform.check": "สินค้าคงคลังผูกตรวจสอบ",
    "message.aegOutboundOrderDetail.title.batchInformation": "ข้อมูลแบทช์",
    "message.aegOutboundOrderDetail.title.skuVariety": "SKU",
    "message.views.workbench.warehouse": "คลังสินค้า",
    "message.views.workbench.currentQuantity": "ปริมาณปัจจุบัน",
    "message.aegOutboundOrderDetail.consignColumn.gmtConfirmReceiveStr": "ยืนยันเวลาที่ได้รับ",
    "message.outboundView.table.skuQuantity": "ปริมาณ",
    "message.views.scItemView.gmtModified": "แก้ไขเวลา",
    "message.aegOutboundOrderDetail.title.totalQtyDec": "ปริมาณ",
    "message.aegInboundDetail.title.logisticLogs": "บันทึกโลจิสติก",
    "message.taskCenterView.title.createdTime": "สร้างเวลา",
    "message.button.setting": "การตั้งค่า",
    "message.table.fulfillment.scItemName": "ชื่อสินค้า SC",
    "message.CreateTransferOrder.entityCode": "คลังสินค้าแหล่งที่มา",
    "message.outboundView.button.importBtn": "นำเข้า",
    "message.views.inventoryLedger.orderTypeMap.OTHER": "อื่นๆ",
    "message.table.fulfillment.tradeOrderItemId": "หมายเลขคำสั่งซื้อสินค้า",
    "message.aegOutboundOrderDetail.title.orderStatus": "สถานะการสั่งซื้อ",
    "message.aegInboundDetail.title.orderStatus": "สถานะการสั่งซื้อ",
    "message.transform.shopBindingWaitingMention": "ผูกเก็บคาดว่าจะใช้เวลาไม่กี่นาทีโปรดอย่าปิดหน้าปัจจุบัน",
    "message.views.inventoryLedger.orderTypeMap.CHECK_IN": "วงจรนับกำไร",
    "message.aegInboundDetail.title.remart": "Remart",
    "message.views.inventoryLedger.orderTypeMap.ADJUST_OUT": "ปรับออก",
    "message.views.scItemView.deleteRelatedPlatformSku": "ลบรายการที่เกี่ยวข้อง",
    "message.lzdInboundCreateView.addSkuView.serialNumber": "หมายเลขซีเรียล",
    "message.outboundView.table.orderStatus": "สถานะการสั่งซื้อ",
    "message.lzdInboundDetail.title.sellerName": "ชื่อผู้ขาย",
    "message.views.workbench.fulfillmentOrderItemId": "ID รายการสั่งซื้อ",
    "message.drawer.fulfillment.trackingNumbers": "หมายเลขติดตาม",
    "message.views.workbench.inboundOrderNo": "รหัสการสั่งซื้อขาเข้า",
    "message.views.workbench.toInbound": "TO inbound คำกริยา",
    "message.inboundView.alert.prompt": "พรอมต์",
    "message.views.inventoryLedger.orderTypeMap.IMBALANCE_LOCK": "ล็อคคลังสินค้า",
    "message.views.workbench.gmv": "GMV",
    "message.aegInboundDetail.logisticColumns.operator": "ผู้ประกอบการ",
    "message.views.publishTemplateView.deleteTemplate": "ลบแม่แบบ",
    "message.lzdInboundCreateView.addSkuView.barcodes": "บาร์โค้ด",
    "message.table.fulfillment.itemTaxActualFee": "ภาษีสินค้าค่าธรรมเนียมจริง",
    "message.views.scItemView.serialNumberManagement": "การจัดการหมายเลขซีเรียล",
    "message.lzdInboundCreateView.tableColumn.sellerPostcode": "รหัสโพสต์",
    "message.views.publishTemplateView.merchant": "พ่อค้า",
    "message.lzdOutboundViewDetail.title.orderStatus": "สถานะการสั่งซื้อ",
    "message.views.publishTemplateView.gmtModified": "แก้ไขเวลา",
    "message.message.fulfillment.chooseOneOrder": "เลือกอย่างน้อยหนึ่งคำสั่งสำหรับการจัดส่ง!",
    "message.login.task_center": "ศูนย์งาน",
    "message.button.export": "ส่งออก",
    "message.views.liveInventory.shipper": "ผู้จัดส่ง",
    "message.views.stockAllocation.adjustStockFailed": "ปรับสต็อกล้มเหลว",
    "message.views.stockAllocation.channelName": "ชื่อช่อง",
    "message.views.scItemView.weight": "น้ำหนัก",
    "message.transform.inventoryBind": "ผูกสินค้าคงคลัง",
    "message.menu.inventoryAging": "อายุสินค้าคงคลัง",
    "message.outboundView.button.AegTemplate": "แม่แบบ AE",
    "message.lzdInboundDetail.title.skus": "SKU",
    "message.aegInboundDetail.purchaseItemColumn.receivedNormalQty": "ได้รับจำนวนปกติ",
    "message.table.fulfillment.tradePayTime": "เวลาจ่ายการค้า",
    "message.views.publishTemplateView.submit": "ส่งไว",
    "message.card.fulfillment.warehouseCode": "รหัสคลังสินค้า",
    "message.lzdInboundCreateView.addSkuView.queryView.platformSku": "SKU แพลตฟอร์ม",
    "message.views.liveInventory.sellableOccupy": "สงวน sellable",
    "message.views.scItemView.sureDelete": "แน่ใจว่าจะลบ?",
    "message.menu.inventoryReconciliation": "การปรองดองสินค้าคงคลัง",
    "message.lzdOutboundViewDetail.title.basicInformation": "ข้อมูลพื้นฐาน",
    "message.transform.boundShop": "ร้านค้าผูก",
    "message.views.stockAllocation.adjustRuleSuccess": "ปรับความสำเร็จของกฎ",
    "message.CreateTransferOrder.senderInfo": "ข้อมูลผู้ส่ง",
    "message.views.workbench.channelOrderQuantity": "ปริมาณการสั่งซื้อช่อง",
    "message.views.inventoryAging.fulfillmentSkuName": "ชื่อ SKU ตามความต้องการ",
    "message.CreateTransferOrder.senderPostCode": "ผู้ส่งรหัสไปรษณีย์",
    "message.card.fulfillment.receiverMobile": "ตัวรับสัญญาณมือถือ",
    "message.table.fulfillment.tradeCreateTime": "สร้างเวลาการค้า",
    "message.transform.orderCheck": "ICP/IO ตรวจสอบการสั่งซื้อ",
    "message.aegOutboundOrderDetail.title.merchantName": "ชื่อร้านค้า",
    "message.views.stockAllocation.channelLock": "ล็อคช่อง",
    "message.views.productPublishView.clickDownloadPublishTemplate": "ดาวน์โหลดแม่แบบเผยแพร่",
    "message.transform.failDetail": "โปรดดูรายละเอียดเกี่ยวกับความล้มเหลว",
    "message.lzdInboundDetail.title.purchaseOrderCode": "ใบสั่งซื้อไม่มี",
    "message.aegOutboundOrderDetail.title.logisticLogs": "เข้าสู่ระบบโลจิสติก",
    "message.lzdInboundCreateView.tableColumn.contactPerson": "ชื่อผู้ติดต่อ",
    "message.views.liveInventory.platform": "แพลตฟอร์ม",
    "message.table.fulfillment.reverseTradeOrderId": "รหัสคำสั่งซื้อขายย้อนกลับ",
    "message.views.workbench.yoy": "Yoy",
    "message.aegOutboundOrderDetail.title.storeCode": "รหัสร้านค้า",
    "message.inboundView.table.createTime": "สร้างเวลา",
    "message.table.fulfillment.action": "การกระทำ",
    "message.table.fulfillment.itemActualPaidFee": "ค่าธรรมเนียมการชำระเงินที่เกิดขึ้นจริง",
    "message.aegOutboundOrderDetail.logisticColumns.operateTime": "เวลาใช้งาน",
    "message.views.workbench.totalProductSold": "ขายผลิตภัณฑ์ทั้งหมด",
    "message.aegOutboundOrderDetail.title.totalReturnQuantity": "ปริมาณผลตอบแทน",
    "message.login.switch_to_th_th": "เปลี่ยนเป็นภาษาไทย",
    "message.views.workbench.thisWeek": "สัปดาห์นี้",
    "message.views.scItemView.sureBind": "แน่ใจว่าจะผูก?",
    "message.table.fulfillment.buyerId": "รหัสผู้ซื้อ",
    "message.aegOutboundOrderDetail.consignColumn.supplierName": "ชื่อผู้ผลิต",
    "message.taskCenterView.title.source": "แหล่งที่มา",
    "message.aegInboundDetail.title.channel": "ช่อง",
    "message.views.productView.category": "หมวดหมู่สินค้า",
    "message.aegOutboundOrderDetail.logisticColumns.operator": "ผู้ประกอบการ",
    "message.views.scItemView.barcode": "บาร์โค้ด",
    "message.aegInboundDetail.title.storeCode": "รหัสร้านค้า",
    "message.views.inventoryAging.platform": "แพลตฟอร์ม",
    "message.outboundView.title.warehouseList": "คลังสินค้า",
    "message.inboundView.table.expectedTime": "คาดว่าเวลา",
    "message.views.stockAllocation.ruleAllocation": "ปรับกฎ",
    "message.lzdInboundCreateView.tableColumn.estimatedTime": "เวลาโดยประมาณ",
    "message.common.input": "กรุณาใส่",
    "message.inboundView.alert.title": "คุณแน่ใจหรือไม่ว่าจะยกเลิก?",
    "message.views.scItemView.category": "หมวดหมู่สินค้า",
    "message.views.inventoryLedger.orderTypeMap.COORDINATE_IN": "การโอนสินค้าขาเข้า",
    "message.lzdOutboundViewDetail.title.mobile": "มือถือ",
    "message.aegOutboundOrderDetail.consignColumn.reserveOrderNo": "สำรองหมายเลข",
    "message.views.scItemView.fulfillmentTitle": "ชื่อ fulfillmentsku",
    "message.table.fulfillment.actualPaidFee": "ค่าธรรมเนียมการจ่ายจริง",
    "message.views.scItemView.basicInfo": "ข้อมูลพื้นฐาน",
    "message.button.reset": "รีเซ็ต",
    "message.views.workbench.orderQuantityTendency": "แนวโน้มปริมาณการสั่งซื้อ",
    "message.inboundView.button.exportSelectedOrder": "ส่งออกคำสั่งซื้อที่เลือก",
    "message.views.inventoryReconciliation.ledgerDetail": "รายละเอียดบัญชีแยกประเภท",
    "message.views.inventoryLedger.inventoryTypeMap.transferOnWay": "โอนทาง",
    "message.inboundView.table.supplier": "ผู้จัดจำหน่าย",
    "message.transform.bindCheckException": "การตรวจสอบการผูกมัดสินค้าคงคลังเป็นข้อยกเว้น",
    "message.card.fulfillment.promiseLatestDate": "สัญญาวันที่ล่าสุด",
    "message.lzdInboundDetail.title.sellerInformation": "ข้อมูลผู้ขาย",
    "message.lzdInboundCreateView.addSkuView.fulfilmentSku": "การตอบสนอง SKU",
    "message.views.workbench.orderQuantityRank": "การจัดอันดับปริมาณการสั่งซื้อ",
    "message.common.search": "ค้นหา",
    "message.outboundView.table.detail": "รายละเอียด",
    "message.inboundView.button.importBtn": "นำเข้า",
    "message.views.scItemView.platformSku": "แพลตฟอร์ม SKU",
    "message.views.productPublishView.submit": "ส่งไว",
    "message.views.dashboardScore.dashboardName.all_order_quantity": "ปริมาณการสั่งซื้อทั้งหมด",
    "message.transform.operateStore": "ดำเนินการร้านค้า",
    "message.aegInboundDetail.title.purchaseOrderCode": "รหัสสั่งซื้อ",
    "message.inboundView.table.detail": "รายละเอียด",
    "message.transform.authList": "รายชื่อการอนุมัติ",
    "message.aegOutboundOrderDetail.purchaseItemColumn.brandName": "ชื่อแบรนด์",
    "message.views.liveInventory.shopName": "ชื่อร้าน",
    "message.views.scItemView.downShelf": "ชั้นวางลง",
    "message.transform.shipperCheck": "ตรวจสอบผู้จัดส่ง",
    "message.views.inventoryReconciliation.startDateStock": "เริ่มต้นวันที่สต็อก",
    "message.aegInboundDetail.title.expectedTime": "คาดว่าเวลา",
    "message.views.activityInventory.fulfillmentSkuCode": "รหัสสินค้า SKU",
    "message.views.inventoryLedger.orderTypeMap.REFOUND_IN": "การตอบสนองย้อนกลับขาเข้า",
    "message.aegInboundDetail.title.batchInformation": "ข้อมูลแบทช์",
    "message.table.fulfillment.trackingNumbers": "หมายเลขติดตาม",
    "message.views.workbench.thisMonth": "เดือนนี้",
    "message.card.fulfillment.tradeCreateTime": "สร้างเวลาการค้า",
    "message.menu.publishTemplateView": "แม่แบบ",
    "message.taskCenterView.table.gmtCreated": "สร้างเวลา",
    "message.aegInboundDetail.logisticColumns.operateTime": "เวลาการดำเนินงาน",
    "message.aegInboundDetail.goodsTable.title": "ผู้ขาย SKU",
    "message.inboundView.title.inboundOrder": "หมายเลขคำสั่งขาเข้า",
    "message.views.workbench.shopOrderQuantityData": "สัดส่วนของปริมาณการสั่งซื้อ",
    "message.views.productView.platformTitle": "ชื่อ",
    "message.views.inventoryLedger.orderTypeMap.COORDINATE_OUT": "การโอนสต็อกขาออก",
    "message.inboundView.button.search": "ค้นหา",
    "message.views.productView.mainShop": "ร้านหลัก",
    "message.menu.ownerTransfer.title": "Ownertransfer",
    "message.aegOutboundOrderDetail.title.remark": "หมายเหตุ",
    "message.views.inventoryReconciliation.changeTypeMap.totalLost": "หายไป",
    "message.login.switch_to_in_id": "Beralih ke bahasa Indonesia"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@alife_mcms_crossborder-merchant-web_front_end@0.0.20@@alife/mcms_crossborder-merchant-web_front_end/th-th.js
// module id = gpQ1
// module chunks = 16